<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />

            <div class="text-center">
              <img
                src="../../assets/img/icon/maskGroup.svg"
                style="width: 20%"
              />
              <div
                class="mt-2 sub-title-card text-black"
                style="color: #000a2c"
              >
                Mad Scientist
              </div>
            </div>
            <br />
            <br />
            <div class="list-grade">
              <div class="float-left">
                <label class="ml-3">Unlock Your Badge</label>
                <br />
                <label class="ml-3 sub-title-card text-black"
                  >You will get 1000 bonus points this month if<br />
                  you complete this challenge.
                </label>
              </div>
              <div style="clear: both"></div>
            </div>
            <br />
            <div class="list-grade">
              <div class="float-left">
                <label class="ml-3 text-muted"
                  >Completed Math Quiz so far</label
                >
                <br />
                <h1 class="text-black ml-3">10/10 Quiz</h1>
              </div>
              <div style="clear: both"></div>
            </div>
          </div>
        </div>
      </div>
    </CContainer>
    <div class="bottom-center mt-5">
      <CButton class="btn-select-blue mt-5" @click="OpenClaimPopup()"
        >Claim Rewards</CButton
      >
    </div>
    <div class="header-top">Yusoff"s Badge</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
    <CModal size="md" :show.sync="ClaimModal">
      <div class="text-center">
        <h3 class="custom-title-popup" style="color: #000a2c">Confirm Claim</h3>
        <br />
      </div>
      <div class="text-center">
        <h4 class="sub-title-header" style="color: #000a2c">
          You are claiming <br />
          <strong style="color:blue">1000 bonus points</strong><br />
          for your bonus challenge.
        </h4>
        <br />
      </div>
      <div class="text-center">
        <CButton class="btn-select-blue mt-5">Confirm</CButton>
      </div>
      <div class="text-center">
        <CButton class="btn-select-white mt-2">Cancel</CButton>
      </div>
    </CModal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ClaimModal: false,
    };
  },
  methods: {
    OpenClaimPopup() {
      this.ClaimModal = true;
    },
    GoToChangeName() {
      this.$router.push("/ParentProfile/ChangeName");
    },
    GoToChangeGrade() {
      this.$router.push("/ParentProfile/ChangeGrade");
    },
    GoToChangeExam() {
      this.$router.push("/ParentProfile/ChangeExam");
    },
    GoToAddMoreSubject() {
      this.$router.push("/ParentProfile/AddMoreSubjects");
    },
    GoBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

.class-teach-name {
  padding: 4px 1px;
  top: 45px;
  /* height: 40px; */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;

  /* Pure/White */

  color: #ffffff;

  /* Inside auto layout */

  /* flex: none;
  order: 0;
  flex-grow: 0; */
}
.custom-btn-add {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;

  color: #007cef;
}
.custom-btn-deactive {
  position: absolute;
  left: 0%;
  right: 0.61%;
  top: 0%;
  bottom: 0%;

  /* Body/1/Semibold */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  /* identical to box height, or 24px */

  color: #f85954;
}
.custom-text-deactive {
  position: absolute;
  width: 162px;
  height: 22px;
  left: 107px;
  top: 25px;

  /* Title/1/Semibold */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  /* identical to box height */

  text-align: center;

  /* Black/Dark-001 */

  color: #000a2c;
}
</style>